import React from 'react';
import { View } from '../../../components/Common/react-native-components';
import Discovery from '../components/Discovery';
import { useTheme } from '@hmsexp/component-library';
import styles from './style';

const InsightsContainer = () => {
  const { palette } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: palette.white }]}>
      <Discovery />
    </View>
  );
};

export default InsightsContainer;
